export interface BaseFileModel {
  id: number;
  name: string;
  fileSize: number;
  fileType: string;
}

export interface ReusableFileModel extends BaseFileModel {
  activityId?: number;
  activityName?: string;
}

